// extracted by mini-css-extract-plugin
module.exports = {"container":"_965a7eb"};